import React, {Component} from 'react';
import * as firebase from 'firebase';
import {Link} from 'react-router-dom';
import MetaTags from 'react-meta-tags';

export default class Personal extends Component {
  constructor(){
    super();
    this.state = {
      birthday: '',
      otherMail: '',
      phone: '',
      address: '',
      gender: '',
      quiz: [],
      Authority: '',
      passState: '',
      applyForChoice: ''
    }
  }
  componentDidMount() {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        var userId = firebase.auth().currentUser.uid
        const rootRef = firebase.database().ref('users/').child(userId).child('UserProfile')
        rootRef.update({
          email: user.email ? user.email : null,
          displayName: user.displayName ? user.displayName : null,
          photoURL: user.photoURL ? user.photoURL : null
        })
        rootRef.on('value', snap => {
          this.setState({
            email: snap.val().email,
            displayName: snap.val().displayName,
            photoURL: snap.val().photoURL,
            birthday: snap.val().birthday,
            otherMail: snap.val().otherMail,
            phone: snap.val().phone,
            address: snap.val().address,
            gender: snap.val().gender,
            Authority: snap.val().Authority
          })
          
        })
        

      } else {
        window.location = ('/')
      }
    })
  }
  render() {
    return(
      <article className="Box">
        <MetaTags>
            <title>草學藥事 || Dashbord</title>
            <meta id="og-title" property="og:title" content="Dashbord" />
        </MetaTags>
       <h3>個人檔案</h3>
       <table>
       <tbody>
        <tr>
         <td>帳戶相片</td>
         <td><img src={this.state.photoURL} alt="圖片獲取失敗" style={Jeyu.UserPhoto} /></td>
        </tr>
        <tr>
         <td>會員帳號ID</td>
         <td>{this.state.email}</td>
        </tr>
        <tr>
         <td>會員名稱</td>
         <td>{this.state.displayName}</td>
        </tr>
        <tr>
         <td>性別</td>
         <td>{this.state.gender}</td>
        </tr>
        <tr>
         <td>出生日期</td>
         <td>{this.state.birthday}</td>
        </tr>
        <tr>
         <td>電子信箱</td>
         <td>{this.state.otherMail}</td>
        </tr>
        <tr>
         <td>手機號碼</td>
         <td>{this.state.phone}</td>
        </tr>
        <tr>
         <td>聯絡地址</td>
         <td>{this.state.address}</td>
        </tr>
        <tr style={{display: this.state.Authority ? 'table-row' : 'none'}}>
         <td>平台權限</td>
         <td>{this.state.Authority}</td>
        </tr>
        </tbody>
       </table>
       <Link to="/UserProfile/EditPersonal" className="btnDefault">修改個人檔案</Link>
      </article>
    )
  }
}

const Jeyu = {
  UserPhoto: {
    display: 'block',
    borderRadius: 50,
    width: 100,
    height: 100
  },
  hidden: {
    overflowX: 'hidden'
  }
}



// WEBPACK FOOTER //
// ./src/View/Personal.js